import React from 'react';
import VerificationModal from "./VerificationModal";


class EnrollmentRequestsTableRow extends React.Component {
  initialState = {
    isLoading: false,
    attachment: null,
    mimeType: '',
    step: 1,
    declineReason: '',
    error: '',
    showModal: false,
    validated: false,
    filename: '',
    vin: '',
    orgId: '',
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  getAttachments = (vin, orgId) => {
    const obj = {
      link: `${localStorage.getItem(
          'api_host'
      )}/api/infleet/${vin}/attachments-json`,
      object: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          orgId: `${orgId}`,
          traceId: '00000000-0000-0000-0000-000000000000',
        },
      },
    };

    fetch(obj.link, obj.object)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            this.getImage(vin, orgId);

            this.setState({
              attachmentId: data.id,
              mimeType: data.mimeType,
              filename: data.filename,
              vin: data.vin,
              orgId: data.orgId,
            });
          }
        });
  };

  getImage = (vin, orgId) => {
    const obj = {
      link: `${localStorage.getItem('api_host')}/api/infleet/${vin}/attachments`,
      object: {
        method: 'GET',
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          orgId: `${orgId}`,
          traceId: '00000000-0000-0000-0000-000000000000',
        },
      },
    };

    fetch(obj.link, obj.object)
        .then((response) => response.blob())
        .then((blob) => {
          this.setState({ attachment: URL.createObjectURL(blob) });
        });
  };

  accept = (vin, orgId) => {
    const obj = {
      link: `${localStorage.getItem('api_host')}/api/infleet/vins/review`,
      object: {
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          traceId: '00000000-0000-0000-0000-000000000000',
        },
        body: JSON.stringify({ status: 'ENROLLMENT_APPROVED', vin: `${vin}`, orgId: `${orgId}` }),
      },
    };

    fetch(obj.link, obj.object).then(async (resp) => {
      if (!resp.ok) {
        // Attempt to extract the backend error message if available
        const errorData = await resp.json().catch(() => null);
        const errorMessage = errorData?.message || `Error: ${resp.status} - ${resp.statusText}`;
        throw new Error(errorMessage);
      }
      if (resp.status === 200) {
        return null;
      }
      return resp.json();
    })
        .then(() => {
          this.setState(this.initialState);
          this.props.getData();
          this.handleClose();
        })
        .catch((error) => {
          this.setState({ errorMessage: error.message, showErrorModal: true });
        });
  };

  decline = (vin, orgId) => {
    this.setState({ error: '' });

    if (this.state.declineReason) {
      const obj = {
        link: `${localStorage.getItem('api_host')}/api/infleet/vins/review`,
        object: {
          method: 'PATCH',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            traceId: '00000000-0000-0000-0000-000000000000',
          },
          body: JSON.stringify({
            status: 'ENROLLMENT_REJECTED',
            vin: `${vin}`,
            orgId: `${orgId}`,
            reason: this.state.declineReason,
          }),
        },
      };

      fetch(obj.link, obj.object)
          .then(async (resp) => {
            if (!resp.ok) {
              const errorData = await resp.json().catch(() => null);
              const errorMessage = errorData?.message || `Error: ${resp.status} - ${resp.statusText}`;
              throw new Error(errorMessage);
            }
            if (resp.status === 200) {
              return null;
            }
            return resp.json();
          })
          .then(() => {
            this.setState(this.initialState);
            this.props.getData();
            this.handleClose();
          })
          .catch((error) => {
            this.setState({ errorMessage: error.message, showErrorModal: true });
          });
    } else {
      this.setState({ error: 'Bitte einen Ablehnungsgrund auswählen.' });
    }
  };

  renderErrorModal = () => {
    return (
        this.state.showErrorModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h5>Error</h5>
                <p>{this.state.errorMessage}</p>
                <button onClick={() => this.setState({ showErrorModal: false })}>Close</button>
              </div>
            </div>
        )
    );
  };

  changeStep = (index) => {
    this.setState({ step: index });
  };

  changeSelect = (event) => {
    if(event.target.value === 'andere'){
      this.changeStep(3);
      this.setState({declineReason: '', validated: false})
    }else{
      this.changeStep(2);
      this.setState({ declineReason: event.target.value, validated: true });
    }
  };

  setCustomReason = (event) => {
    this.setState({ declineReason: event.target.value }, ()=> {
      if(this.state.declineReason.length > 100 || this.state.declineReason.length === 0) {
        this.setState({validated: false})
      }else {
        this.setState({validated: true})
      }
    })
  };

  handleClose = () => {
    this.setState({ showModal: false, validated: false, declineReason: '' });
    this.changeStep(1);
  };

  handleShow = async () => {
    await this.getAttachments(this.props.request.vin, this.props.request.orgId);
    this.setState({ showModal: true });
  };

  handleAccept = async () => {
    await this.accept(this.props.request.vin, this.props.request.orgId);
  };

  handleDecline = async () => {
    await this.decline(this.props.request.vin, this.props.request.orgId);
  };

  goBack = () => {};

  mapCountry = (code) => {
    if (!code) {
      return '-';
    }
    const countries = {
      DE: 'Deutschland',
      AT: 'Österreich',
      FR: 'Frankreich',
      PL: 'Polen',
      CZ: 'Tschechien',
    };

    if (countries[code] !== undefined) {
      return countries[code];
    } else {
      return code;
    }
  };

  render() {
    const { request } = this.props;
    if (!request) {
      return (
          <tr>
            <td colSpan="5" style={{ textAlign: 'center' }}>No data</td>
          </tr>
      );
    }

    const country = this.mapCountry(request?.countryCode);
    const vin = request?.vin || '-';
    const registrationDate = request?.registrationDate || '-';
    const status = request?.status || '-';


    return (
        <>
          {this.renderErrorModal()}
          <tr>
            <td>{vin}</td>
            <td>{registrationDate || '-' }</td>
            <td>{country}</td>
            <td>{status}</td>
            <td>
              {<VerificationModal
                  isLoading={this.state.isLoading}
                  step={this.state.step}
                  request={request}
                  attachment={this.state.attachment}
                  mimeType={this.state.mimeType}
                  filename={this.state.filename}
                  accept={this.handleAccept}
                  decline={this.handleDecline}
                  changeStep={this.changeStep}
                  changeSelect={this.changeSelect}
                  error={this.state.error}
                  showModal={this.state.showModal}
                  handleClose={this.handleClose}
                  handleShow={this.handleShow}
                  country={country}
                  setCustomReason={this.setCustomReason}
                  declineReason={this.state.declineReason}
                  validated={this.state.validated}
              />
              }
            </td>
          </tr>
        </>
    );
  }
}
export default EnrollmentRequestsTableRow;
